import { evaluationColors, opacityNext, opacitySuggestion } from "./App";
import MoveEvaluator from "./MoveEvaluator";
import StoneMenu from "./StoneMenu";

const Stone = ({ sign, showAnalysis, moveNumber, nodeId, move,
                 moveScore, gameScore, alternativeMoves, alternativeSimplestMoves, 
                 showMarkers, moveData, evaluationThresholds, isLoading, 
                 stoneMenu, handleStoneMenu, closeStoneMenu }) => {

  let color = null
  if(showMarkers && showAnalysis && !!moveData) {
    const moveEvaluator = new MoveEvaluator(evaluationThresholds)
    let evaluationCurrent = null
    // If the current move is a top move that's also simple, we color it blue 
    if(alternativeSimplestMoves.some(moveInfo => moveInfo.move === move)) {
      evaluationCurrent = "simplest"
    } else {
      evaluationCurrent = moveEvaluator(moveData)
    }
    color = evaluationColors(opacitySuggestion)[evaluationCurrent]
  }

  return (
    <div style="overflow: visible">
      <div
        className="shudan-stone" 
        onContextMenu={(e) => handleStoneMenu(e, { moveData: moveData })} >
        <div className={`shudan-stone-image shudan-sign_${sign}`} style="position: absolute; z-index: 10"></div>
        {!!color && 
        <svg viewBox="0 0 1 1" xmlns="http://www.w3.org/2000/svg" style="position: absolute; z-index: 20">
        <circle 
            cx="0.5"
            cy="0.5"
            r={0.14}
            vectorEffect="non-scaling-stroke"
            fill={color} />
            </svg>
        }
      </div>
    </div>
  );
};

export default Stone;